// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import 'react-datepicker/dist/react-datepicker.css';

import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import S from './styles';
import CommonContext from '../../../contexts/CommonContext';
import { getMultilangs } from '../../../components/common/Multilang';
import MemberContext from '../../../contexts/MemberContext';

const InterestCardForm = (): JSX.Element => {
  const common = useContext(CommonContext);
  const interests = getMultilangs(common.interests);
  const member = useContext(MemberContext);

  const [selectedInterests, setSelectedInterests] = useState<number[] | null>(null);
  useEffect(() => {
    // console.log({member})
    setSelectedInterests(member.interestIds);
  }, []);

  useEffect(() => {
    if (selectedInterests && member.interestIds !== selectedInterests) {
      member.update({ interestIds: selectedInterests });
    }

  }, [selectedInterests]);

  const updateInterest = async (id: number) => {
    if (selectedInterests) {
      if (selectedInterests.includes(id)) {
        setSelectedInterests(selectedInterests.filter(data => data !== id))
      } else {
        setSelectedInterests(data => data ? [...data, id] : data)
      }
      console.log({ id, selectedInterests })
    }
  }
  const renderInterestCardOptions = () => {
    return (
      <S.ButtonOptionWrapper>
        {interests.map((data, index) => {
          return (
            <S.Button key={index} selected={selectedInterests ? selectedInterests.includes(data.id) : false} onClick={() => updateInterest(data.id)}>{data.name}</S.Button>
          )
        })}
      </S.ButtonOptionWrapper>
    )
  }

  return (
    <S.InterestCard>
      <S.InterestCardTitle><FormattedMessage id="G008" /></S.InterestCardTitle>
      <S.InterestCardSubtitle>
        <FormattedMessage id="G009" />
      </S.InterestCardSubtitle>
      {renderInterestCardOptions()}
    </S.InterestCard>
  )
}

export { InterestCardForm as default };
